<template>
    <div>
        <pageHeader></pageHeader>
        <!--广告页面-->
        <div class="banner clearfix">
            <div class="banner-wrap">
                <div class="banner-slider">
                    <div class="banner-item animated" 
                        :class="{active:bannerModel.active,fadeIn:bannerModel.fadeIn,fadeOut:bannerModel.fadeOut}" 
                        v-for="bannerModel in bannerList" 
                        :key="bannerModel.id"
                        :style="{backgroundImage: 'url('+bannerModel.picUrl+')'}">
                    </div>
                    <div class="slide">
                        <a href="javascript:void(0);" 
                        v-for="(slideModel,index) in bannerList" 
                        :key="slideModel.id"
                        class="slide-item"
                        :class="{active:slideModel.active}" @click="bannerFadIn(index)">
                        </a>	
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper main-body w1200 bg-white" style="padding:0 15px;">
            <!--推荐课程-->
            <div class="recommend mt10">
                <section class="section-title font-size-18">
                    精品课程
                    <router-link class="more" to="/courseList"><i class="iconfont more-icon">&#xe678;</i></router-link>
                </section>
                <div>
					<ul class="recommend-course clearfix">
						<li class="recommend-course-item fl" v-for="(courseModel,index) in recommandCourseList" :key="index" @click="showCourse(courseModel.id)">
							<div class="course-img">
								<img :src="courseModel.picBigUrl">
								<!-- <img :src="'http://image.xueyoubangbang.com/' + courseItemModel.picBigUrl"> -->
							</div>
							<div class="recommend-course-detail">
								<p class="recommend-course-name">{{courseModel.courseName}}</p>
								<div class="clearfix recommend-course-info">
									<span class="fl">{{courseModel.numByStudent}}人购买</span>
									<span  class="fr font-red">{{courseModel.realPrice == "0"?"免费":'￥&nbsp;&nbsp;'+courseModel.realPrice}}</span>
								</div>
							</div>
						</li>
					</ul>
                </div>
            </div>

            <!-- 校区展示 -->
            <div class="campus mt10" id="campus">
                <section class="section-title font-size-18">
                    校区展示
                </section>
                <div class="campus-content clearfix">
                    <div class="display-inline campus-big">
                        <img src="../../assets/images/campus-small-1.jpg" />
                    </div>
                    <div class="display-inline campus-small">
                        <div class="fl"><img src="../../assets/images/campus-small-2.jpg"></div>
                        <div class="fl"><img src="../../assets/images/campus-small-3.jpg"></div>
                        <div class="fl"><img src="../../assets/images/campus-small-4.jpg"></div>
                        <div class="fl"><img src="../../assets/images/campus-small-5.jpg"></div>
                    </div>
                </div>
            </div>
        </div>
        <pageFooter></pageFooter>
    </div>
</template>
<script>
import pageHeader from '../header/header'
import pageFooter from "../footer/pageFooter"

export default {
    name: 'app',
    components: {
        pageHeader,
        pageFooter
    },
    data() {
        return {
            bannerIndex:0,
            bannerList:[
                {
                    id:1,
                    picUrl: 'http://www.maryenglish.com.cn/img/banner01.jpg',
                    courseId:0,
                    active: true,
                    fadeIn: true,
                    fadeOut: false
                }
			],
			recommandCourseList:[]		//推荐课程
			
        }
    },
    created(){
        this.init();
	},
    methods:{
        init(){
            console.log("begin init")
			setTimeout(this.bannertimer,4000);
			
			this.getHotsCourse();
		},
		
        bannerFadIn(index){
            this.bannerIndex = index
			for(var i=0;i<this.bannerList.length;i++){
				if(index == i){
					this.bannerList[i].fadeIn = true;
					this.bannerList[i].active = true;
					this.bannerList[i].fadeOut = false;
				}else{
					this.bannerList[i].fadeIn = false;
					this.bannerList[i].active = false;
					this.bannerList[i].fadeOut = true;
				}
			}
		},
        bannertimer(){
            console.log(this.bannerList.length)
			for(var i=0;i<this.bannerList.length;i++){
                if(this.bannerIndex ==this.bannerList.length-1){
                    this.bannerIndex = -1
				}
				var slider = this.bannerList[i]
				slider.active = false;
				this.bannerList[i].fadeIn = false;
				this.bannerList[i].active = false;
				this.bannerList[i].fadeOut = true;
				if(i == this.bannerIndex+1){
                    slider.active = true;
					this.bannerList[i].fadeIn = true;
					this.bannerList[i].active = true;
					this.bannerList[i].fadeOut = false;
				}
			}
			this.bannerIndex++;
			setTimeout(this.bannertimer, 4000);
		},
		//加载推荐课程
		getHotsCourse(){
			this.$http.post(this.baseUrl()+'/mobile/tbCourse/getCourseList',       // 还可以直接把参数拼接在url后边
				this.$qs.stringify({
					recommendFlag:'1',
					page: 1,
					pageSize: 8
				}),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
			).then(function(res){
				
				this.recommandCourseList = res.data.data;
				console.log(res.data.data);

			}).catch(function (error) {
				console.log(error);
			});
		},
		showCourse(courseId){
			this.$router.push('/courseInfo/'+courseId);
		}
    }
}
</script>
<style>
    .banner{
		width: 100%;background-color: #fff;
	}
    .banner-wrap{
		width: 100%;background-color: #fff;
		position: relative;
		/*z-index: 1;*/
	}
	.banner-slider{
		width:100%;
		/*height:300px;*/
		height: 360px;
		overflow:hidden;
		position: relative;
	}
	.banner-slider .banner-item{
		width:100%;
		/*height:300px;*/
		height: 360px;
		display:block;
		position:absolute;
		left:0px;top:0px;
		z-index:0;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}
	.banner-slider .banner-item.active{
		z-index:1;
	}
	#banner_id{
		width: 100%;
		height: 12px;
		position:absolute;
		z-index:1;
		left:0;
		bottom:0px;
	}
	.slide{
		width: 100%;
		text-align: center;
		position:absolute;
		left: 0;
		bottom: 10px;
		z-index: 10;
	}
	.slide a{
		width:16px;
		height:4px;
		overflow:hidden;
		cursor:pointer;
		background-color: #fff;
		margin:0 10px;
		display:inline-block;
	}
	.slide a.active{
		background-color: #f49d40;
	}
    .section-title{
		position: relative;
	}
	.section-title .more{
		position: absolute;
		cursor: pointer;
		right: 0;
		color: #666666;
	}
	.section-title .more .more-icon{
		font-size: 12px;
	}
	.section-title .arrow .prev,
	.section-title .arrow .next{
		border:1px solid #dfdfdf;
		padding: 1px 4px 1px 3px;
	}
	.section-title .arrow .prev{
		border-right:none;
		margin-right: -4px;
	}
	.section-title .arrow .iconfont{
		color: #999;
		cursor: pointer;
		font-size: 6px;
	}

	/*推荐课程新布局*/
	.recommend-course{
		padding: 17px 0 13px;
	}
	.recommend-course .recommend-course-item{
		margin-right: 14px;
		cursor: pointer;
	}
	.recommend-course .recommend-course-item:last-child{
		margin-right: 0;
	}
	.recommend-course-item .course-img{
		width: 278px;
		height: 168px;
		margin-bottom: 15px;
	}
	.recommend-course-item .course-img img{
		width: 282px;
		height: 168px;
	}
	
	.recommend-course-detail .recommend-course-name{
		color: #2c3e50;
		font-weight: bold;
		padding-bottom: 16px;
	}
	.recommend-course-info span:first-child{
		color: #666;
	}
	.recommend-course-info span:last-child{
		font-size: 16px;
	}
</style>